/**
 * Entity types
 * - To be replace by auto-generated types from schema
 */
/* eslint-disable import/no-extraneous-dependencies */
import { IGetStagesStatsOutput } from '@nicejob-library/campaign-stats';
import { CloudMutation } from '@nicejob-library/cloud-function-microservice/types';
import { IContentMedium, IContentSchema } from '@nicejob-library/content-templates/types';
import { IAccountInvitation } from '@nicejob-library/data-platform-implementation/entities/AccountInvitation';
import { IActiveInstance } from '@nicejob-library/data-platform-implementation/entities/ActiveInstance';
import { IAPIRequest } from '@nicejob-library/data-platform-implementation/entities/APIRequest';
import { IAuthentication } from '@nicejob-library/data-platform-implementation/entities/Authentication';
import { ICall } from '@nicejob-library/data-platform-implementation/entities/Call';
import { ICallTracking } from '@nicejob-library/data-platform-implementation/entities/CallTracking';
import {
    CampaignObjective,
    CampaignRuleCalcMethod,
    CampaignRuleOperator,
    CampaignRuleType,
    CampaignSubjectKind,
    DefaultCampaign,
} from '@nicejob-library/data-platform-implementation/entities/Campaign/enums';
import { ICase } from '@nicejob-library/data-platform-implementation/entities/Case';
import { ICatalogProduct } from '@nicejob-library/data-platform-implementation/entities/CatalogProduct';
import { IClickTracker } from '@nicejob-library/data-platform-implementation/entities/ClickTracker';
import { IUserRole } from '@nicejob-library/data-platform-implementation/entities/common';
import { ICompany } from '@nicejob-library/data-platform-implementation/entities/Company';
import {
    CompanyProductPlan,
    CompanyProductPlanDate,
} from '@nicejob-library/data-platform-implementation/entities/Company/ProductStatus/types';
import { CompanyProductId } from '@nicejob-library/data-platform-implementation/entities/Company/types';
import { ICompanyAliases } from '@nicejob-library/data-platform-implementation/entities/CompanyAliases';
import { ICompanyInvitation } from '@nicejob-library/data-platform-implementation/entities/CompanyInvitation';
import { IConsentEvent } from '@nicejob-library/data-platform-implementation/entities/ConsentEvent';
import { IConversation } from '@nicejob-library/data-platform-implementation/entities/Conversation';
import { ParticipantKind } from '@nicejob-library/data-platform-implementation/entities/Conversation/enums';
import { IConvertStats } from '@nicejob-library/data-platform-implementation/entities/ConvertStats';
import { IEmployee } from '@nicejob-library/data-platform-implementation/entities/Employee';
import { IGiftConfiguration } from '@nicejob-library/data-platform-implementation/entities/GiftConfiguration';
import { ISugarwishGiftConfigurationParameters } from '@nicejob-library/data-platform-implementation/entities/GiftConfiguration/GiftConfigurationParameters/SugarwishGiftConfigurationParameters';
import { IGiftIntent } from '@nicejob-library/data-platform-implementation/entities/GiftIntent';
import { IGiftTemplate } from '@nicejob-library/data-platform-implementation/entities/GiftTemplate';
import { IGoogleAnalytics } from '@nicejob-library/data-platform-implementation/entities/GoogleAnalytics';
import { IIntegration } from '@nicejob-library/data-platform-implementation/entities/Integration';
import { IIntercomAppTokenLink } from '@nicejob-library/data-platform-implementation/entities/IntercomAppTokenLink';
import { IKeyTranslation } from '@nicejob-library/data-platform-implementation/entities/KeyTranslation';
import { MessageTemplateMethod } from '@nicejob-library/data-platform-implementation/entities/MessageTemplate/enums';
import { INetwork } from '@nicejob-library/data-platform-implementation/entities/Network';
import { NetworkName } from '@nicejob-library/data-platform-implementation/entities/Network/enums';
import { IOAuth } from '@nicejob-library/data-platform-implementation/entities/OAuth';
import { IOAuth2Credential } from '@nicejob-library/data-platform-implementation/entities/OAuth2Credential';
import { IOAuth2LoginSession } from '@nicejob-library/data-platform-implementation/entities/OAuth2LoginSession';
import { IOAuth2PasswordReset } from '@nicejob-library/data-platform-implementation/entities/OAuth2PasswordReset';
import { IOAuth2User } from '@nicejob-library/data-platform-implementation/entities/OAuth2User';
import { IOAuth2UserInvitation } from '@nicejob-library/data-platform-implementation/entities/OAuth2UserInvitation';
import { IOpportunityStats } from '@nicejob-library/data-platform-implementation/entities/OpportunityStats';
import { IPasswordReset } from '@nicejob-library/data-platform-implementation/entities/PasswordReset';
import { IPaymentTransaction } from '@nicejob-library/data-platform-implementation/entities/PaymentsHub/Payments/PaymentTransaction';
import { IPaymentSettings } from '@nicejob-library/data-platform-implementation/entities/PaymentsHub/PaymentSettings';
import { IPerson } from '@nicejob-library/data-platform-implementation/entities/Person';
import { IPersonChannel } from '@nicejob-library/data-platform-implementation/entities/Person/PersonChannel';
import { IPersonActivity } from '@nicejob-library/data-platform-implementation/entities/PersonActivity';
import { IPhoto } from '@nicejob-library/data-platform-implementation/entities/Photo';
import { IProduct } from '@nicejob-library/data-platform-implementation/entities/Product';
import { IQueuedEvent } from '@nicejob-library/data-platform-implementation/entities/QueuedEvent';
import { IReferredPerson } from '@nicejob-library/data-platform-implementation/entities/ReferredPerson';
import { IResellerSettings } from '@nicejob-library/data-platform-implementation/entities/ResellerSettings';
import { IReview } from '@nicejob-library/data-platform-implementation/entities/Review';
import { IReviewCrawl } from '@nicejob-library/data-platform-implementation/entities/ReviewCrawl';
import { IReviewSiteVerification } from '@nicejob-library/data-platform-implementation/entities/ReviewSiteVerification';
import { IReviewSource } from '@nicejob-library/data-platform-implementation/entities/ReviewSource';
import { ISocialMedia } from '@nicejob-library/data-platform-implementation/entities/SocialMedia';
import { ITag } from '@nicejob-library/data-platform-implementation/entities/Tag';
import { ITopic } from '@nicejob-library/data-platform-implementation/entities/Topic/';
import { TopicSlug } from '@nicejob-library/data-platform-implementation/entities/Topic/enums';
import { IUnsubscribeTracker } from '@nicejob-library/data-platform-implementation/entities/UnsubscribeTracker';
import { IUser } from '@nicejob-library/data-platform-implementation/entities/User';
import { LanguagePreference } from '@nicejob-library/data-platform-implementation/entities/User/enums';
import { IViewTracker } from '@nicejob-library/data-platform-implementation/entities/ViewTracker';
import { IWebhook } from '@nicejob-library/data-platform-implementation/entities/Webhook';
import { IWebhookPublication } from '@nicejob-library/data-platform-implementation/entities/WebhookPublication';
import { IWebsiteActivity } from '@nicejob-library/data-platform-implementation/entities/WebsiteActivity';
import { IWebsitePerformanceStats } from '@nicejob-library/data-platform-implementation/entities/WebsitePerformanceStats';
import { IWidgetActivity } from '@nicejob-library/data-platform-implementation/entities/WidgetActivity';
import { ThreatType } from '@nicejob-library/gcp-web-risk';
import { ILanguage } from '@nicejob-library/internationalization';
import { IPubsubMetadata } from '@nicejob-library/pubsub/types';
import { LDContext } from 'launchdarkly-js-client-sdk';
import { Scope } from '../common/SCOPES';
import { IEntityKey } from './common.types';

export type OptionalEntityBase<
    K extends IEntityBase<string> = IEntityBase<string>,
    F extends keyof K = 'key' | 'id' | 'updated_at' | 'created_at' | 'deleted' | 'deleted_at'
> = Omit<K, F> & Partial<Pick<K, F>>;

export type PartialEntity<K extends IEntityBase<string> = IEntityBase<string>> = Omit<
    Partial<K>,
    'key'
> & {
    key: K['key'];
};

//  Utility
export type EntityToSave<T extends IEntityBase<string>> = Omit<
    T,
    Exclude<keyof IEntityBase<string>, 'key'>
>;

// Entities that can be shared to authorized third parties
export type SharedEntity =
    | Person
    | Job
    | Invoice
    | Conversation
    | Story
    | Photo
    | Campaign
    | CampaignEnrollment
    | Employee
    | User
    | Review
    | Case
    | Payment;

export type SharedEntityKind = SharedEntity['key']['kind'];

export type ImportedNiceJobDataKinds =
    | 'Person'
    | 'Invoice'
    | 'Payment'
    | 'Job'
    | 'Visit'
    | 'Employee'
    | 'CatalogProduct';

//  Common elements
export enum CreationMethod {
    SDK = 'SDK',
    API = 'API',
    MESSAGE = 'MESSAGE',
    SHARE = 'SHARE',
}

export type DomainKey = 'API' | 'APP' | 'MICROSITE' | 'TRACKING';

//  CDP Migration Utility Types
type CDPEntityWithOmittedProperties<CDPEntity, OmittedProperties extends keyof CDPEntity> = Omit<
    CDPEntity,
    OmittedProperties | 'committed_at'
>;

type ICDPToDatastoreTranslation<
    CDPEntity, // CDP entity interface from data-platform-implementation library
    OmittedProperties extends keyof CDPEntity, // Union of all keys to omit (ie. CDP primary keys and additional metadata fields)
    Kind extends string,
    Namespace extends string = string,
    ID extends string = string
> = IEntityBase<Kind, Namespace, ID> & CDPEntityWithOmittedProperties<CDPEntity, OmittedProperties>;

export type EntityMetadata = {
    [field: string]:
        | string
        | number
        | boolean
        | null
        | Array<string | number | boolean | null>
        | undefined;
};

/**
 * Entities
 *
 * IMPORTANT - The entity interface definitions below are NOT to be updated directly.
 *             If you update an entity's schema, please just update the related type in the
 *             data-platform-implementation library.
 */
export interface IEntityBase<
    K extends string,
    NS extends string = string,
    ID extends string = string
> {
    key: IEntityKey<K, NS, ID>;
    id: ID;
    created_at: Date;
    updated_at: Date;
    deleted: boolean;
    deleted_at: Date | null;
}

export interface AccountInvitation
    extends ICDPToDatastoreTranslation<
        IAccountInvitation,
        'account_invitation_id',
        'AccountInvitation',
        'Account'
    > {}

export interface ActiveInstance
    extends ICDPToDatastoreTranslation<
        IActiveInstance,
        'active_instance_id',
        'ActiveInstance',
        'Globals'
    > {}

export interface Authentication
    extends ICDPToDatastoreTranslation<
        IAuthentication,
        'authentication_id' | 'company_id',
        'Authentication'
    > {}

export interface Call extends ICDPToDatastoreTranslation<ICall, 'call_id' | 'company_id', 'Call'> {}

export interface CallTracking
    extends ICDPToDatastoreTranslation<ICallTracking, 'call_tracking_id', 'CallTracking'> {}

export interface Case extends ICDPToDatastoreTranslation<ICase, 'case_id' | 'company_id', 'Case'> {}

export interface CatalogProduct
    extends ICDPToDatastoreTranslation<
        ICatalogProduct,
        'catalog_product_id' | 'company_id',
        'CatalogProduct'
    > {}

export interface ClickTracker
    extends ICDPToDatastoreTranslation<IClickTracker, 'click_tracker_id', 'ClickTracker'> {}

export interface Company extends ICDPToDatastoreTranslation<ICompany, 'company_id', 'Company'> {}

export interface CompanyAliases
    extends ICDPToDatastoreTranslation<ICompanyAliases, 'company_aliases_id', 'CompanyAliases'> {}

export interface CompanyInvitation
    extends ICDPToDatastoreTranslation<
        ICompanyInvitation,
        'company_invitation_id' | 'company_id',
        'CompanyInvitation'
    > {}

export interface ConsentEvent
    extends ICDPToDatastoreTranslation<
        IConsentEvent,
        'consent_event_id' | 'company_id',
        'ConsentEvent'
    > {}

export interface Conversation
    extends ICDPToDatastoreTranslation<
        IConversation,
        'conversation_id' | 'company_id',
        'Conversation'
    > {}

export interface ConvertStats
    extends ICDPToDatastoreTranslation<
        IConvertStats,
        'convert_stats_id' | 'company_id',
        'ConvertStats'
    > {}

export interface Employee
    extends ICDPToDatastoreTranslation<IEmployee, 'employee_id' | 'company_id', 'Employee'> {}

export interface GoogleAnalytics
    extends ICDPToDatastoreTranslation<
        IGoogleAnalytics,
        'google_analytics_id' | 'company_id',
        'GoogleAnalytics'
    > {}

export interface Integration
    extends ICDPToDatastoreTranslation<
        IIntegration,
        'integration_id' | 'company_id',
        'Integration'
    > {}

export interface IntercomAppTokenLink
    extends ICDPToDatastoreTranslation<
        IIntercomAppTokenLink,
        'intercom_app_token_link_id',
        'IntercomAppTokenLink',
        'OAuth2'
    > {}

export interface Network
    extends ICDPToDatastoreTranslation<INetwork, 'network_id', 'Network', 'Globals', NetworkName> {}

export interface OAuth2Credential
    extends ICDPToDatastoreTranslation<
        IOAuth2Credential,
        'oauth2_credential_id',
        'OAuth2Credential',
        'OAuth2'
    > {}

export interface OAuth2UserInvitation
    extends ICDPToDatastoreTranslation<
        IOAuth2UserInvitation,
        'oauth2_user_invitation_id',
        'OAuth2UserInvitation',
        'OAuth2'
    > {}

export interface OpportunityStats
    extends ICDPToDatastoreTranslation<
        IOpportunityStats,
        'opportunity_stats_id' | 'company_id',
        'OpportunityStats'
    > {}

export interface OAuth2LoginSession
    extends ICDPToDatastoreTranslation<
        IOAuth2LoginSession,
        'oauth2_login_session_id',
        'OAuth2LoginSession'
    > {}
export interface OAuth2PasswordReset
    extends ICDPToDatastoreTranslation<
        IOAuth2PasswordReset,
        'oauth2_password_reset_id',
        'OAuth2PasswordReset'
    > {}

export interface PasswordReset
    extends ICDPToDatastoreTranslation<IPasswordReset, 'password_reset_id', 'PasswordReset'> {}

export interface PaymentSettings
    extends ICDPToDatastoreTranslation<IPaymentSettings, 'committed_at', 'PaymentSettings'> {}

export interface Person
    extends ICDPToDatastoreTranslation<IPerson, 'person_id' | 'company_id', 'Person'> {}

export interface PersonActivity
    extends ICDPToDatastoreTranslation<
        IPersonActivity,
        'person_activity_id' | 'company_id',
        'PersonActivity'
    > {}

export interface ReferredPerson
    extends ICDPToDatastoreTranslation<
        IReferredPerson,
        'referred_person_id' | 'company_id',
        'ReferredPerson'
    > {}

export interface ResellerSettings
    extends ICDPToDatastoreTranslation<
        IResellerSettings,
        'reseller_settings_id',
        'ResellerSettings',
        'Account'
    > {}

export interface Review
    extends ICDPToDatastoreTranslation<IReview, 'review_id' | 'company_id', 'Review'> {}

export interface ReviewCrawl
    extends ICDPToDatastoreTranslation<
        IReviewCrawl,
        'review_crawl_id' | 'company_id',
        'ReviewCrawl'
    > {}

export interface ReviewSiteVerification
    extends ICDPToDatastoreTranslation<
        IReviewSiteVerification,
        'review_site_verification_id' | 'company_id',
        'ReviewSiteVerification'
    > {}

export interface ReviewSource
    extends ICDPToDatastoreTranslation<
        IReviewSource,
        'review_source_id' | 'company_id',
        'ReviewSource'
    > {}

export interface SocialMedia
    extends ICDPToDatastoreTranslation<
        ISocialMedia,
        'social_media_id' | 'company_id',
        'SocialMedia'
    > {}

export interface Tag extends ICDPToDatastoreTranslation<ITag, 'tag_id' | 'company_id', 'Tag'> {}

export interface User extends ICDPToDatastoreTranslation<IUser, 'user_id', 'User', 'User'> {}

export interface UnsubscribeTracker
    extends ICDPToDatastoreTranslation<
        IUnsubscribeTracker,
        'unsubscribe_tracker_id',
        'UnsubscribeTracker'
    > {}

export interface ViewTracker
    extends ICDPToDatastoreTranslation<IViewTracker, 'view_tracker_id', 'ViewTracker'> {}

export interface Webhook extends ICDPToDatastoreTranslation<IWebhook, 'webhook_id', 'Webhook'> {}

export interface WebhookPublication
    extends ICDPToDatastoreTranslation<
        IWebhookPublication,
        'webhook_publication_id',
        'WebhookPublication'
    > {}

export interface WebsiteActivity
    extends ICDPToDatastoreTranslation<
        IWebsiteActivity,
        'website_activity_id' | 'company_id',
        'WebsiteActivity'
    > {}

export interface WebsitePerformanceStats
    extends ICDPToDatastoreTranslation<
        IWebsitePerformanceStats,
        'website_performance_stats_id' | 'company_id',
        'WebsitePerformanceStats'
    > {}

export interface WidgetActivity
    extends ICDPToDatastoreTranslation<
        IWidgetActivity,
        'widget_activity_id' | 'company_id',
        'WidgetActivity'
    > {}

/**
 * Supplemented/Populated Entities
 */

// Employee
export interface SupplementedEmployee extends Employee {
    initials: string;
    name: string;
    friendly_phone: string | null;
}

export interface PopulatedEmployee extends SupplementedEmployee {
    profile_photo: Photo | null;
}

export interface PopulatedCall extends Call {
    person: Person;
}

export interface Campaign<K extends IEntityBase<string> = IEntityBase<string>>
    extends IEntityBase<'Campaign'> {
    name: string;
    description?: string | null;
    processionType: 'SEQUENTIAL' | 'SINGLE';

    default_campaign: DefaultCampaign | null;
    objective: CampaignObjective | null;
    subject_kind: CampaignSubjectKind;

    active: boolean;
    hidden: boolean;
    default_hidden: boolean;
    deferred_campaign_id: string | null;
    multipleEnrollments: boolean;
    minimumReEnrollLatency: string | null;
    paused: boolean;
    primetimeOnly: boolean;
    is_modified?: boolean;

    entryRules: Array<CampaignRuleCollection<K>>;
    exitRules: Array<CampaignRuleCollection<K>>;
}

export enum ReviewCampaignEnrollmentLimit {
    ONE_DAY = '1 days',
    SIX_MONTHS = '180 days',
}

export interface CampaignRuleCollection<EntityKind extends IEntityBase<string>> {
    equivalency: number;
    rules: Array<CampaignRule<EntityKind>>;
}

export const GIFT_CAMPAIGN_OBJECTIVES: CampaignObjective[] = [
    CampaignObjective.WELCOME_NEW_CUSTOMERS,
    CampaignObjective.REWARD_LOYAL_CUSTOMERS,
];

export type GiftCampaignObjective =
    | CampaignObjective.WELCOME_NEW_CUSTOMERS
    | CampaignObjective.REWARD_LOYAL_CUSTOMERS;

// This type exists solely to add support of the GiftIntent to the Rules Engine.
export interface GiftIntent extends IEntityBase<'GiftIntent'>, IGiftIntent {}

export interface CampaignRule<EntityKind extends IEntityBase<string>> {
    equivalency: number;
    kind: EntityKind['key']['kind'];
    subjectField: Extract<keyof Omit<EntityKind, 'key'>, string> | 'id';
    rule: CampaignRuleSingleEntity<EntityKind> | CampaignRuleAggregate<EntityKind>;
}

export type EntityPropertyScalarType = string | boolean | number | Date | null;
export type EntityPropertyType = EntityPropertyScalarType | Array<EntityPropertyScalarType>;
export type CampaignRuleValue = EntityPropertyScalarType | EntityPropertyScalarType[];

export interface EntityPropertyRule<
    EntityKind extends IEntityBase<string>,
    Calc extends CampaignRuleCalcMethod = CampaignRuleCalcMethod
> {
    calc?: Calc; // Default: 'SUM'
    property: Extract<keyof Omit<EntityKind, 'key'>, string> | '_COUNT_' | 'network';
    operator?: CampaignRuleOperator; // Default EQUAL_TO
    value: CampaignRuleValue;
    equivalency: number;
}

export interface CampaignRuleEntityFilter<EntityKind extends IEntityBase<string>>
    extends EntityPropertyRule<EntityKind, CampaignRuleCalcMethod.SUM> {}

export interface CampaignRuleAggregateFilter<EntityKind extends IEntityBase<string>>
    extends EntityPropertyRule<EntityKind> {}

export interface CampaignRuleSingleEntity<EntityKind extends IEntityBase<string>> {
    type: CampaignRuleType.SINGLE;
    entity_filters: Array<CampaignRuleEntityFilter<EntityKind>>;

    // aggregate_filters are IGNORED for SINGLE-type rules
    aggregate_filters?: null | Array<CampaignRuleAggregateFilter<EntityKind>>;
}
export interface CampaignRuleAggregate<EntityKind extends IEntityBase<string>> {
    type: CampaignRuleType.AGGREGATE;
    entity_filters: Array<CampaignRuleEntityFilter<EntityKind>>;
    aggregate_filters: Array<CampaignRuleAggregateFilter<EntityKind>>;
}

export interface CampaignEnrollment extends IEntityBase<'CampaignEnrollment'> {
    campaign_id: string;
    legacy_sequence_queue_id: string | null;
    tags: Array<string>;

    subjectNamespace: string | null;
    subjectKind: Campaign['subject_kind'];
    subjectId: string;

    user_id: string | null;
    employee_ids: Array<string>;
    legacy_user_id: string;

    entryEntities: Array<IEntityKey>;
    story_id: string | null;

    successful: boolean;
    successful_at: Date | null;
    successEntities: Array<IEntityKey>;

    usurped: boolean;
    usurped_at: Date | null;
    usurped_by: string | null;

    eligible: boolean;

    ended: boolean;
    ended_at: Date | null;

    paused: boolean;
    stopped: boolean;
    stopped_at: Date | null;
    stopped_by: string | null;

    immediate_exit: boolean;
}

export interface CampaignEnrollmentProfile
    extends Pick<
            CampaignEnrollment,
            | 'id'
            | 'subjectNamespace'
            | 'subjectKind'
            | 'subjectId'
            | 'created_at'
            | 'successful'
            | 'ended'
            | 'stopped'
            | 'usurped'
        >,
        Pick<
            SupplementedPerson,
            | 'first_name'
            | 'last_name'
            | 'name'
            | 'initials'
            | 'email'
            | 'phone'
            | 'company'
            | 'position'
        > {}

export interface CampaignRequest extends IEntityBase<'CampaignRequest'> {
    slug: string | null;
    legacy_message_id: string | null;

    campaign_id: string;
    campaign_enrollment_id: string;
    campaign_stage_id: string;
    message_template_id: string | null;
    content_template_id: string | null;
    gift_configuration_id: string | null;
    gift_quantity: number | null;
    skipped: boolean;
    skipped_because?:
        | null
        | 'MESSAGE_SEND_FAILED'
        | 'MESSAGE_DELIVERY_FAILED'
        | 'GIFT_INTENT_CREATION_FAILED'
        | 'LANDLINE_PHONE'
        | 'SUBJECT_UNSUBSCRIBED'
        | 'SUBJECT_BLOCKED'
        | 'SUBJECT_MISSING_CONTACT_INFO'
        | 'SUBJECT_MISSING_CONSENT'
        | 'CAMPAIGN_INACTIVE'
        | 'CAMPAIGN_PAUSED'
        | 'CAMPAIGN_STAGE_PAUSED'
        | 'CAMPAIGN_ENROLLMENT_PAUSED';
    sent: boolean;
    method: MessageTemplate['method'] | null;
    email_id: string | null;
    sms_id: string | null;
    gift_intent_id: string | null;
    successful: boolean;
}

export interface CampaignStage extends IEntityBase<'CampaignStage'> {
    campaign_id: string;
    message_template_id: string | null;
    content_template_id: string | null;
    gift_configuration_id: string | null;
    gift_quantity: number | null;
    method: MessageTemplateMethod | null;
    rules: Array<CampaignRuleCollection<IEntityBase<string>>> | null;
    paused: boolean;
    order: number;
    wait: string;
}

export interface PopulatedSugarwishGiftConfigurationParameters
    extends ISugarwishGiftConfigurationParameters {
    content_template: IContentSchema<IContentMedium>;
}

export interface PopulatedGiftConfiguration extends Omit<IGiftConfiguration, 'parameters'> {
    gift_template: IGiftTemplate;
    parameters: PopulatedSugarwishGiftConfigurationParameters;
}

export interface PopulatedCampaignStage extends CampaignStage {
    messageTemplate: MessageTemplate | null;
    contentTemplate: ContentTemplate | null;
    // @todo @gifting: We might need to remove this imported type. It is using the Data
    // Platform's type, and Data-Platform relies on this type file.
    gift_configuration: PopulatedGiftConfiguration | null;
}

export interface CampaignStageData {
    id: string;
    sends: number;
    reads: number;
    clicks: number;
    successes: number;
}

export interface CampaignStats {
    company_id: string;
    campaign_id: string;
    total_enrollments: number;
    total_successful_entities: number;
    successful_enrollments: number;
    total_unique_exited_subjects: number;
    data_points: Array<CampaignDataPoint>;
    campaign_stage_summaries: Array<CampaignStageSummary>;
    meta_data: {
        scale: StatsScale;
        date_format: string;
        interval: number;
    };
}

export interface IRepeatsCampaignInsights {
    repeat_services: number;
    compare_repeat_services: number;
    people_exited: number;
    conversion_rate: number;
    stages_stats: IGetStagesStatsOutput;
}

export interface CampaignDataPoint {
    successes: number;
    successes_change: number;
    start_date: Date;
    end_date: Date;
    campaign_stages: Array<DataPointCampaignStage>;
}

export interface DataPointCampaignStage {
    id: string;
    method: MessageTemplateMethod;
    successes: number;
    successes_change: number;
    deleted: boolean;
    deleted_at: Date | null;
}

export interface CampaignStageSummary {
    id: string;
    method: MessageTemplateMethod;
    sends: number;
    opens: number;
    clicks: number;
    successes: number;
    unsubscribes: number;
    deleted: boolean;
    deleted_at: Date | null;
}

export enum ReviewJourneyModalStep {
    REVIEW_SOURCES = 'review_sources',
    APPS = 'apps',
    INVITE_PAST_CUSTOMERS = 'invite_past_customers',
    START_AUTOMATION = 'start_automation',
}

export interface Convert extends IEntityBase<'Convert'> {
    domain: string | null;
    asana_task_id: string | null;
    customers: {
        why_call: string | null;
        common_objections: string | null;
        customer_types: string | null;
    } | null;
    services: {
        primary_service: string | null;
        secondary_service: string | null;
        company_goal: string | null;
        process_steps: string | null;
        services_showcase: string | null;
    } | null;
    locations: {
        primary_city: string | null;
        other_city: string | null;
    } | null;
    what_sets_apart: {
        top_reason: string | null;
        company_story: string | null;
        guarantee: string | null;
        certifications_or_awards: string | null;
        insurance: string | null;
    } | null;
    credentials: {
        awards: string | null;
        certifications: string | null;
        liability_insurance: string | null;
    } | null;
    website_preferences: {
        style_preferences: string | null;
        style_examples: string | null;
        feedback_on_site_one: string | null;
        feedback_on_site_two: string | null;
        feedback_on_site_three: string | null;
    } | null;
    assets: {
        badge: Array<string>;
        brand: Array<string>;
        image: Array<string>;
    } | null;
    seo: {
        investing: boolean | null;
        report_example: string | null;
    } | null;
    setup_status: {
        progress: number;
        current_page: string;
        migrated: boolean | null;
    };
    completed_at: Date | null;
}
export interface ContentTemplate<Medium extends IContentMedium = IContentMedium>
    extends IEntityBase<'ContentTemplate'>,
        IContentSchema<Medium> {
    base_content_template_id?: string | null;
    metadata?: Record<string, any>;
    tags: Array<string>;
}

/**
 * @type OmittedContentTemplate
 * @description This type is used to create a ContentTemplate without the key field
 */
export type OmittedContentTemplate = Omit<
    ContentTemplate,
    Exclude<keyof IEntityBase<string>, 'key'>
>;

/**
 * @type ContentTemplateLanguageDictionary
 * @description This type is used to create a dictionary of ContentTemplates, where the key is the language
 */
export type ContentTemplateLanguageDictionary = { [key in ILanguage]: OmittedContentTemplate };

export interface ConvertStatsV2 extends ConvertStatsV2Fields {
    company_id: string;
}

export interface ConvertStatsV2AllCompanies extends ConvertStatsV2Fields {
    company_data: Array<ConvertStatsV2>;
}

interface ConvertStatsV2Fields {
    leads: {
        lead_count: number;
        web_lead_count: number;
        phone_lead_count: number;
        data_points: Array<{
            lead_count: number;
            lead_change: number;
            lead_percent_change: number;
            phone: {
                lead_count: number;
                lead_change: number;
                lead_percent_change: number;
            };
            web: {
                lead_count: number;
                lead_change: number;
                lead_percent_change: number;
            };
            start_date: number;
            end_date: number;
        }>;
    };
    visitors: {
        visitor_count: number;
        data_points: Array<{
            visitor_count: number;
            visitor_change: number;
            visitor_percent_change: number;
            start_date: number;
            end_date: number;
        }>;
    };
    channels_summaries: {
        [key: string]: {
            lead_count: number;
            visitor_count: number;
        };
    };

    meta_data: {
        scale: StatsScale;
        date_format: string;
    };
}

export interface Email extends IEntityBase<'Email'> {
    message_template_id?: string;
    inputVariables: {
        [variable_name: string]: string | Array<string> | undefined;
    };

    content_template_id?: string;
    content_template_render_arguments?: Record<string, any>;

    to: Omit<CommunicationAddressee, 'phone'>;
    sending_at: Date;
    service: string | null;

    subject: string | null;
    content: string;
    fingerprint: string;
    duplicate: boolean;
    reply_to: string | null;

    from: Omit<CommunicationAddressee, 'phone'>;
    sent_at: Date | null;
    success: boolean;
    failure_reason: string | null;

    risk_profile: MessageRiskProfile;

    //  Email-specific
    mandrill_status: string | null;
    mandrill_email_id: string | null;
    mandrill_reject_reason: string | null;
    mandrill_error_name: string | null;
    mandrill_error_message: string | null;

    is_inbound?: boolean | null;
}

export interface MessageRiskProfile {
    uris: Array<{
        uri: string;
        threat_types: ThreatType[];
    }>;
}

interface CommunicationAddressee {
    email: string;
    name: string | null;
    phone: string;
}

export interface Goal extends IEntityBase<'Goal'> {
    topic: GoalTopic;
    current_count: number;
    target_count: number;
    achievement_entity_id: string | null;
    achievement_entity_kind: string | null;
    achievement_entity_namespace: string | null;
    user_id: string;
    is_achieved: boolean;
    achieved_at: Date | null;
}

export enum GoalTopic {
    CALL_CREATED = 'CALL_CREATED',
    LEAD_FORM_CREATED = 'LEAD_FORM_CREATED',
    REVIEW_CREATED = 'REVIEW_CREATED',
    RECOMMENDATION_CREATED = 'RECOMMENDATION_CREATED',
}

export interface Invoice extends IEntityBase<'Invoice'> {
    network: string;
    external_source_id: string;
    person_ids: Array<string>;
    integration_id: string;
    employee_ids: Array<string>;
    tags: Array<string>;

    total: number;
    subtotal: number | null;
    balance: number;
    discount: number;
    discounts: Array<{
        external_id: string | null;
        name: string | null;
        description: string | null;
        amount: number | null;
        percentage: number | null;
    }>;
    taxes: Array<{
        external_id: string | null;
        name: string | null;
        description: string | null;
        amount: number | null;
        percentage: number | null;
    }>;
    currency: string | null;
    line: Array<{
        external_id: string | null;
        amount: number | null;
        description: string | null;
    }>;

    external_invoice_name: string | null;
    external_created_at: Date;
    status: InvoiceStatus | null;
    paid: boolean;
    paid_at: Date | null;
    description: string | null;
    metadata: Record<string, any>;
}

export enum InvoiceStatus {
    DRAFT = 'draft',
    OPEN = 'open',
    PAID = 'paid',
    UNCOLLECTIBLE = 'uncollectible',
    VOID = 'void',
}

export interface Item {
    catalog_product_id: string;
    external_source_id: string;
    name: string;
    description?: string | null;
    amount: Amount;
    quantity: number;
}

export interface Job extends IEntityBase<'Job'> {
    employee_ids: Array<string>;
    user_ids: Array<string>;
    photo_ids: Array<string>;
    name: string | null;
    tags: Array<string>;
    external_created_at: Date;
    scheduled_at: Date | null;
    completed_at: Date | null;
    complete: boolean | null;
    amount: number;
    items?: Array<Item>;

    invoice_id: string;
    integration_id: string;
    network: string;
    external_source_id: string;
    person_ids: Array<string>;
}

export interface KeyTranslation
    extends ICDPToDatastoreTranslation<
        IKeyTranslation,
        'key_translation_id',
        'KeyTranslation',
        'Globals'
    > {}

export interface LandingPage extends IEntityBase<'LandingPage'> {
    legacy_page_id: string | null;
    asana_task_id: string | null;
    details: {
        location: string | null;
        service: string | null;
    };
    credentials: {
        awards: string | null;
        certifications: string | null;
        liability_insurance: string | null;
    };
    what_sets_apart: {
        top_reason: string | null;
        recognized_clients: string | null;
        ideal_neighborhoods: string | null;
    };
    additional: {
        content: string | null;
    };
    build_status: LandingPageBuildStatus | null;
    paused: boolean;
    paused_at: Date | null;
}

export enum LandingPageBuildStatus {
    READY = 'READY',
    BUILDING = 'BUILDING',
    LAUNCHING = 'LAUNCHING',
    LAUNCHED = 'LAUNCHED',
}

export interface LeadForm
    extends IEntityBase<'LeadForm'>,
        Omit<SDKBaseEventProperties, 'element_text_content' | 'element_href'> {
    data: Array<LeadFormData>;
    referrer: string | null;
    person_id: string;
    legacy_lead_id: string | null;
    fingerprint: string;
}

export interface PopulatedLeadForm extends LeadForm {
    person: Person;
}

export interface LeadFormData {
    name: string;
    value: string | boolean;
}

export interface LeadWidget extends IEntityBase<'LeadWidget'> {
    custom_url: string;
    custom_fields: Array<{
        type: 'SHORTTEXT' | 'LONGTEXT' | 'CHECKBOX' | 'SELECTOR';
        label: string;
        required: boolean;
        options?: Array<string>;
    }>;
}

export interface LoginSession extends IEntityBase<'LoginSession'> {
    user_id: string;
    userAgent: {
        os: string;
        family: string;
        device: string;
        agent: string;
    };
}

export interface SelectedProduct {
    plan: CompanyProductPlan;
    product: CompanyProductId;
}

export enum OAuthOperationType {
    LOGIN = 'LOGIN',
    SIGN_UP = 'SIGN_UP',
}

export interface OnboardingOAuthState extends IEntityBase<'OnboardingOAuthState'> {
    phone?: string;
    oauth_operation_type?: OAuthOperationType;
    selected_products?: Array<SelectedProduct>;
    coupon?: string;
    referrer?: string;
    post_login_url?: string;
    language: LanguagePreference | null;
}

//  Note that this is the deprecated v1 Match entity
export interface Match extends IEntityBase<'Match'> {
    review_id: string;
    person_id: string;
    certain: boolean;
    perfect_match: boolean;
    similarity: number;
    initialed: boolean;
    probability: number;
    redirects: number;
    strong_redirects: number;
    confirmed: boolean;
    incorrect: boolean;
    version: string;
}
export interface PopulatedMatch extends Match {
    person: PopulatedPerson;
}

export interface Message extends IEntityBase<'Message'> {
    network: string;
    external_source_id: string;
    external_created_at: Date;

    conversation_id: string | null;

    from: Participant;
    to: Array<Participant>;

    // Status should be an enum but currently isn't used
    status: null;
    subject: string | null;
    content: string;
}

export interface Microsite extends IEntityBase<'Microsite'> {
    leads: {
        enable: boolean;
        text: string;
        title: string;
        submit_text: string;
    };
    checkins: {
        enroll_after_checkin: boolean;
        enroll_delay: number;
    };
}

export enum Platform {
    ATOM = 'ATOM',
    NICEJOB = 'NICEJOB',
}

export enum LanguagePreferenceEntity {
    USER = 'user',
    COMPANY = 'company',
}

export interface Photo
    extends ICDPToDatastoreTranslation<IPhoto, 'photo_id' | 'company_id', 'Photo'> {}

export interface MessageTemplate extends IEntityBase<'MessageTemplate'> {
    name: string | null;
    language_preference_entity?: LanguagePreferenceEntity | null;
    legacy_template_id: string | null;
    legacy_parent_template_id: string | null;
    is_default_template: boolean;
    base_message_template_id: string | null;
    method: MessageTemplateMethod;
    permit_duplicate_send: boolean;
    input_variable_specifications: Array<{
        inputVariableName: string | null;
        outputVariableName: string;
        required?: boolean;
        metadata?: boolean;
        array?: boolean;
        scalar?: boolean;
        key?: {
            namespace?: MessageTemplateInputVariableEntity['key']['namespace'] | null;
            kind: MessageTemplateInputVariableEntity['key']['kind'];
        } | null;
        populate?: Array<MessageTemplateInputVariableSpecificationPopulate> | null;

        //  Additional datastore lookup filters
        filter?: Record<string, any>;
    }>;

    click_trackers?: Array<{
        domain?: DomainKey | null;
        href: string;
    }> | null;

    messageData: MessageTemplateMessageData;

    //  Email-only
    unsubscribe_tracker?: boolean;
    template_file?: string;
    template_html_type?: 'MJML' | 'EJS';
    has_plaintext_option?: boolean;
}

export type MessageTemplateInputVariableEntity =
    /** expected */
    | MessageTemplateInputVariableMigratedEntity
    | Goal
    | LeadForm
    | Match
    | Network
    | OAuth2Credential
    | OpportunityStats
    | Person
    | Photo
    | Recommendation
    | Review
    | Story
    | User
    | WebsitePerformanceStats

    /** unexpected */
    | Call
    | CampaignEnrollment
    | Employee;

export type MessageTemplateInputVariableDatastoreEntity = Exclude<
    MessageTemplateInputVariableEntity,
    MessageTemplateInputVariableMigratedEntity
>;

export type MessageTemplateInputVariableSpannerEntity = ICompany;

export type MessageTemplateInputVariableMigratedEntity = IEntityBase<'Company'>;

export interface MessageTemplateEmail extends MessageTemplate {
    method: MessageTemplateMethod.EMAIL;
    messageData: MessageTemplateMessageDataEmail;

    unsubscribe_tracker: boolean;
    template_file: string;
    template_html_type: 'MJML' | 'EJS';
    has_plaintext_option: boolean;
}

export interface MessageTemplateSMS extends MessageTemplate {
    method: MessageTemplateMethod.SMS;
    messageData: MessageTemplateMessageDataSMS;
}

export interface MessageTemplateInputVariableSpecificationPopulate {
    from: string;
    to: string;
    kind: MessageTemplateInputVariableEntity['key']['kind'];

    namespace?: string | null;
    searchField?: string | null;
    fields?: Array<string>;
    populate?: Array<MessageTemplateInputVariableSpecificationPopulate>;
}

export interface MessageTemplateMessageData {
    from?: {
        email?: string | null;
        name: string | null;
        phone?: string | null;
    };
    to:
        | {
              email: string;
              name?: string | null;
          }
        | {
              phone: string;
              name?: string | null;
          };
    subject?: string;
    body: any;
}

export interface MessageTemplateMessageDataEmail extends MessageTemplateMessageData {
    from?: {
        email?: string | null;
        name: string | null;
    };
    to: {
        email: string;
        name?: string | null;
    };
    subject: string;
}

export interface MessageTemplateMessageDataSMS extends MessageTemplateMessageData {
    from?: {
        email?: string | null;
        name: string | null;
    };
    to: {
        phone: string;
        name?: string | null;
    };
}

export interface Amount {
    value: number;
    currency_code: string | null;
}

export interface OAuth extends ICDPToDatastoreTranslation<IOAuth, 'oauth_id', 'OAuth', 'Globals'> {}

export interface Participant {
    id: string | null;
    kind: ParticipantKind;
}

export interface Payment extends IEntityBase<'Payment'> {
    amount: number;
    currency: string | null;
    external_created_at: Date;
    description: string | null;
    tags: Array<string>;
    metadata: Record<string, any>;
    status: PaymentStatus;
    disputed: boolean;
    refunded: boolean;
    amount_refunded: number;

    external_source_id: string;
    invoice_ids: Array<string>;
    integration_id: string;
    person_ids: Array<string>;
    employee_ids: Array<string>;
    network: string;
}

export enum PaymentStatus {
    succeeded = 'succeeded',
    pending = 'pending',
    failed = 'failed',
}

// This type exists solely to add support of the PaymentTransaction to the Rules Engine.
export interface PaymentTransaction
    extends IEntityBase<'PaymentTransaction'>,
        IPaymentTransaction {}

export interface Product
    extends ICDPToDatastoreTranslation<IProduct, 'product_id', 'Product', 'Globals'> {}

export interface Proposal extends IEntityBase<'Proposal'> {
    network: string;
    external_source_id: string;
    integration_id: string;
    person_ids: Array<string>;
    employee_ids: Array<string>;

    external_created_at: Date;
    completed_at: Date | null;
    status: ProposalStatus;
    name: string | null;
    description: string | null;
    tags: Array<string>;

    total: number;
    currency: string | null;
}

export enum ProposalStatus {
    OPEN = 'OPEN',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
}

export interface QueuedEvent
    extends ICDPToDatastoreTranslation<
        IQueuedEvent,
        'queued_event_id',
        'QueuedEvent',
        'Schedule'
    > {}

/**
 * @deprecated
 */
export interface LegacyQueuedEvent<MetadataType extends IPubsubMetadata = IPubsubMetadata>
    extends IEntityBase<'QueuedEvent', 'Schedule'> {
    date: Date | null;

    queue: string;
    status: 'queued' | 'processing' | 'processed' | 'failed';
    published_at: Date | null;
    expired_at: Date | null;

    service: string;
    data: {
        action: CloudMutation;
        input: Record<string, any> | null;
    };
    metadata: MetadataType;
}

export interface Recommendation extends IEntityBase<'Recommendation'> {
    creation_method: CreationMethod;
    network: string | null;
    origin_url: string | null;
    referrer_url: string | null;
    session_id: string | null;
    pageview_id: string | null;
    name: string | null;
    slug: string;
    status: RecommendationStatus;
    message_template_id: string | null;
    email_id: string | null;
    sms_id: string | null;
    from_person_id?: string;
    to_person_id?: string | null;
    user_id: string | null;
    employee_ids: Array<string>;
    has_converted: boolean;
    tags: Array<string>;
    metadata: EntityMetadata;
}

export enum RecommendationStatus {
    PENDING = 'PENDING',
    SENT = 'SENT',
    FAILED = 'FAILED',
    THIRD_PARTY_SHARE = 'THIRD_PARTY_SHARE',
}

export interface RecommendationsCount {
    count: number | null;
}

export interface RecommendationsRate {
    recommendation_rate: number;
    total_people: number;
    recommenders: number;
}

export interface ReferralLead {
    name: string;
    email: string;
    phone: string;
}

interface ResellerWhiteLabelSettings {
    enabled: boolean;
    brand_name: string | null;
    address: string | null;
    app_domain: string | null;
    microsite_domain: string | null;
    tracking_domain: string | null;
    help_center_domain: string | null;
    sales_domain: string | null;
    whats_new_domain: string | null;
    app_icon_id: string | null;
    ios_icon_id: string | null;
    android_icon_id: string | null;
    fav_icon_id: string | null;
    powered_by_photo_id: string | null;
}

export interface ReviewScrape extends IEntityBase<'ReviewScrape'> {
    review_source_id: string;
    spider: string;
    job_id: string;
    fetched: boolean;
    timestamp: Date;

    update_reviews: boolean;
    ignore_pre_crawl: boolean;
    initial_crawl: boolean;

    crawl_url: string;
    crawl_status: string;
}

export interface ReviewStats extends IEntityBase<'ReviewStats'> {
    review_count: number;
    rating_sum: number;
    invite_count: number;
    date_joined: Date;
    daily_stats: Array<ReviewSubStats>;
    monthly_stats: Array<ReviewSubStats>;
    since_joined_stats: ReviewSubStats;
}

export interface ReviewSubStats {
    date: string;
    review_count: number;
    rating_sum: number;
    invite_count: number;
    sub_stats: Array<{
        network: string;
        review_count: number;
        rating_sum: number;
    }>;
}

interface ReviewStatsV2Fields {
    review_count: number;
    rating_sum: number;
    review_count_by_rating: Array<{
        rating: number;
        count: number;
    }>;
    review_source_summaries: Array<{
        review_count: number;
        rating_sum: number;
        network: string;
    }>;
    data_points: Array<{
        review_count: number;
        rating_sum: number;
        review_change: number;
        rating_change: number;
        average_rating: number;
        start_date: number;
        end_date: number;
        review_source_data: Array<{
            review_count: number;
            rating_sum: number;
            rating_change: number;
            review_change: number;
            average_rating: number;
            network: string;
        }>;
    }>;
    meta_data: {
        scale: StatsScale;
        date_format: string;
        interval: number;
    };
}

export interface ReviewStatsV2 extends ReviewStatsV2Fields {
    company_id: string;
}

export interface ReviewStatsV2AllCompanies extends ReviewStatsV2Fields {
    company_data: ReviewStatsV2[];
}

export enum StatsScale {
    MONTH = 'month',
    WEEK = 'week',
    DAY = 'day',
}

export interface Share extends IEntityBase<'Share'> {
    status: 'ready' | 'shared' | 'failed';

    //  Share content
    content_template_id: string | null;
    destination_url: string | null;
    caption: string | null;
    title: string | null;
    description: string | null;
    image_url: string | null;
    image_alt: string | null;

    //  Share content (legacy)
    story_id: string | null;

    //  Share on network
    social_media_id: string;
    network: string | null;
    external_source_id: string | null;
    external_url: string | null;

    //  Share context
    integration_id: string | null;
    user_id: string | null;
    auto_shared: boolean;
}

export interface SMS extends IEntityBase<'SMS'> {
    message_template_id?: string;
    inputVariables: Email['inputVariables'];

    content_template_id?: string;
    content_template_render_arguments?: Email['content_template_render_arguments'];

    to: Omit<CommunicationAddressee, 'email' | 'name'>;
    from: null | Omit<CommunicationAddressee, 'email' | 'name'>;
    sending_at: Date;
    service: string;

    content: string;
    attachments: Array<string>;
    fingerprint: string;
    duplicate: boolean;

    sent_at: Date | null;
    success: boolean;
    failure_reason: string | null;

    risk_profile: MessageRiskProfile;

    //  SMS-specific
    twilio_status: string | null;
    twilio_sms_sid: string | null;
    twilio_error_code: string | null;
    twilio_error_message: string | null;
}

export interface StripeCustomer extends IEntityBase<'StripeCustomer', 'Account'> {
    stripeCustomerId: string;
    credit_card_provider: string | null;
    credit_card_ending: number | null;
    coupon: {
        name: string;
        code: string;
        value: number | null;
        percent: number | null;
        type: 'ONE_TIME' | 'MONTHLY';
    } | null;
    country: string;
    state: string;
    postal_code: string;
    tax_rate: number;
    default_tax_rates: Array<string>;
    testing: boolean;
    reviewly: boolean;
}

export interface Story extends IEntityBase<'Story'> {
    review_ids: Array<string>;
    has_reviews: boolean;
    photo_ids: Array<string>;
    has_photos: boolean;
    share_ids: Array<string>;
    has_shares: boolean;

    campaign_enrollment_ids: Array<string>;
    employee_ids: Array<string>; // Manually-attributed
    person_ids: Array<string>; // Manually-attributed

    legacy_album_id: string | null;
    legacy_shared: boolean;
    legacy_reach: number | null;

    published: boolean;
    caption: string | null;
    location: string | null;
    tags: Array<string>;
    user_id: string | null;
    slug: string;
    hidden: boolean;
    sort_date: Date;
    deleted_preservable: boolean;
    reinstated_at: Date | null;
    has_potential_matches: boolean;
    review_sentiments: Array<'pos' | 'neu' | 'neg'>;
    review_networks: Array<string>;

    stats: null | {
        employee_ids: null | Array<string>;
        person_ids: null | Array<string>;
        topics: null | Array<TopicSlug>;
        has_reply: boolean;
    };
    network: string | null;
    external_source_id: string | null;
}

export interface Topic extends ICDPToDatastoreTranslation<ITopic, 'topic_id', 'Topic', 'Globals'> {}

export interface UnifiedLog<ResultType, InputType = any> extends IEntityBase<'UnifiedLog'> {
    id: string;
    pubsubMessageId: string;
    topic: string;
    data: {
        input: InputType;
        result: ResultType;
    };
    metadata: IPubsubMetadata;

    error: boolean;
    errorMessage: string | null;
    partial: boolean;
    partial_data: string | null;

    created_at: Date;
    updated_at: Date;
}

export interface Visit extends IEntityBase<'Visit'> {
    employee_ids: Array<string>;
    user_ids: Array<string>;
    photo_ids: Array<string>;
    name: string | null;
    tags: Array<string>;
    scheduled_at: Date | null;
    completed_at: Date | null;
    complete: boolean | null;
    amount: number | null;
    invoice_id: string;
    integration_id: string;
    network: string;
    external_source_id: string;
    job_id: string;
    person_id: string;
    external_created_at: Date;
}

export interface WebsiteActivityResponse {
    cursor: string | null;
    websiteActivity: Array<PopulatedWebsiteActivity>;
}

/**
 * Namespace: OAuth2
 */
export interface OAuth2AccessToken extends IEntityBase<'OAuth2AccessToken', 'OAuth2'> {
    client_id: string;
    company_id: string | null;
    refreshToken: string | null;
    accessToken: string;
    expires_in: number;
    scopes: Array<Scope>;
    grant_type: GrantType;
    user_id: string | null;
    legacy_user_id: string | null;
    network: string | null;
    sandbox: boolean;
    api_version: OAuth2Credential['api_version'];
    iOS: boolean;
    expiry: Date;
    refreshed_at: Date;
}

type GrantType = 'client_credentials' | 'authorization_code' | 'refresh_token';

export interface OAuth2RefreshToken extends IEntityBase<'OAuth2RefreshToken', 'OAuth2'> {
    client_id: string;
    company_id: string | null;
    refreshToken: string;
    scopes: Array<Scope>;
    code: string | null;
    user_id: string | null;
    legacy_user_id: string | null;
    network: string | null;
    sandbox: boolean;
    api_version: OAuth2Credential['api_version'];
}

export interface OAuth2User
    extends ICDPToDatastoreTranslation<IOAuth2User, 'oauth2_user_id', 'OAuth2User', 'OAuth2'> {}

/**
 * Namespace: "Tracking"
 */
export interface SDKSessionData {
    network: string;
    browser_id: string | null;
    company_id: string | null;
    ip: string;
    origin_url: string;
    referrer_url: string;
    accept: string;
    user_agent: string;
    browser: string;
    browser_fingerprint: string;
    browser_language: string;
    browser_timezone: number;
    browser_version: string;
    os: string;
    os_version: string;
    city: string;
    region: string;
    country: string;
    latitude: number;
    longitude: number;
    utm_source: string;
    utm_medium: string;
    utm_term: string;
    utm_campaign: string;
    utm_content: string;
    nicejob_click_id: string | null;
    google_click_id: string | null;
    facebook_click_id: string | null;
    screen_height: number;
    screen_width: number;
    last_active_at: Date;
    metadata: EntityMetadata;
}

export interface Session extends IEntityBase<'Session', 'Tracking'>, SDKSessionData {
    name: string | null;
    creation_method: CreationMethod;
    person_id: string | null;
    user_id: string | null;
    employee_ids: Array<string>;
    tags: Array<string>;
    last_active_at: Date;
}

export interface PageView extends IEntityBase<'PageView', 'Tracking'> {
    browser_id: SDKSessionData['browser_id'];
    company_id: string;
    session_id: string;
    origin_url: string;
    referrer_url: string;
    metadata: EntityMetadata | null;
}

export interface SDKBaseElementProperties<M extends EntityMetadata = EntityMetadata, D = any> {
    element_id: string;
    element_classes: Array<string>;
    element_data_attributes: {
        [attribute: string]: string | number | boolean | null;
    };
    element_text_content: string;
    element_href: string;
    data: D;
    tags: Array<string>;

    //  Metadata
    //  -> metadata.person_id confers person_id onto trackers
    metadata: Partial<M> | null;
}

export interface SDKBaseEventProperties extends SDKBaseElementProperties {
    browser_id: SDKSessionData['browser_id'];
    company_id: string | null;
    session_id: string;
    pageview_id: string;
    origin_url: string;
    referrer_url: string;
    network: string;
}

export interface Click extends IEntityBase<'Click', 'Tracking'>, SDKBaseEventProperties {}

export interface View
    extends IEntityBase<'View', 'Tracking'>,
        Omit<SDKBaseEventProperties, 'element_text_content' | 'element_href'> {}

export interface Unsubscribe extends IEntityBase<'Unsubscribe', 'Tracking'> {
    company_id: string;
    email: string;
    metadata: SDKBaseElementProperties['metadata'];
}

export interface SMSUnsubscribe extends IEntityBase<'SMSUnsubscribe', 'Tracking'> {
    company_id: string;
    phone: string;
    metadata: SDKBaseElementProperties['metadata'];
}

export interface SubscriptionUpdateRequest
    extends IEntityBase<'SubscriptionUpdateRequest', 'Account'> {
    order_id: string;
    success: boolean;
    error: string | null;

    testing: boolean;
    reviewly: boolean;

    user_id: string;
    company_id: string;
    account_id: string | null;
    stripeCustomerId: string | null;

    ignore_immediate_charges: boolean;
    dry_run: boolean;
    is_admin: boolean;

    stripe_charge_id: string | null;
    stripe_subscriptions_to_update: ISubscriptionUpdateIndex;
    stripe_subscription_items_to_create: ISubscriptionItemToCreateIndex;
    stripe_subscriptions_to_create: Array<ISubscriptionToCreate>;
    immediate_charges: Array<IImmediateCharge>;

    processed_at: Date | null;

    input: any;
    metadata: any;
}

export interface ISubscriptionItemToCreateIndex {
    [subscription_id: string]: Array<
        ISubscriptionItemToCreate & {
            subscription: string;
        }
    >;
}

export interface ISubscriptionItemToCreate {
    plan: string;
    quantity: number;
    metadata: Record<string, string>;
    prorate?: boolean;
}

export interface ISubscriptionToCreate {
    customer: string;
    default_tax_rates: Array<string>;
    items: Array<ISubscriptionItemToCreate>;
    trial_end?: number | 'now';
}

export interface ISubscriptionUpdateIndex {
    [subscription_id: string]: {
        items: Array<
            | {
                  id: string;
                  deleted: true;
              }
            | {
                  id: string;
                  quantity: number;
                  metadata: Record<string, string>;
              }
        >;
        trial_end?: number | 'now';
    };
}

export interface IImmediateCharge {
    company_id: string;
    unit_cost: number;
    quantity: number;
    product_name: string;
    product_plan: string;
    plan_date: CompanyProductPlanDate;
    charge_id: string;
    metadata: {
        default_tax_rates: string;
        tax_rate: string;
    };
}

/**
 * Namespace: Requests
 */

export interface APIRequest
    extends ICDPToDatastoreTranslation<IAPIRequest, 'api_request_id', 'APIRequest', 'Requests'> {}

export interface WebhookRequest<Body = Record<string, any>>
    extends IEntityBase<'WebhookRequest', 'Requests'> {
    status: WebhookStatus | null;
    external_webhook_id: string | null;
    source: string | null;
    company_id: string | null;
    integration_id: string | null;

    request: {
        method: string | null;
        url: string;
        query: JSON;
        body: Body;
        headers: JSON;
        location: {
            city: string | null;
            region: string | null;
            country: string | null;
        };
        ip: string | null;
    };

    responses: Array<{
        status: number | null;
        response: JSON;
        error: string | null;
        timestamp: Date | null;
        monolith: boolean | null;
    }>;
}

export enum WebhookStatus {
    QUEUED = 'queued',
    PROCESSED = 'processed',
    FAILED = 'failed',
    AUTH_EXPIRED = 'auth_expired',
    DEDUPLICATED = 'deduplicated',
    REQUEUED = 'requeued',
    SPLIT = 'split',
    SKIPPED = 'skipped',
}

/**
 * Populated entities
 */

//  Company
export interface SupplementedCompany extends ICompany {
    friendly_phone: string | null;
    address_string: string | null;
    is_atom_company: boolean;
}

export interface PopulatedCampaignEnrollment extends CampaignEnrollment {
    ongoing: boolean;
    end_date: Date;
    campaignRequests: Array<CampaignRequest>;
    user: PopulatedUser;
    stopped_by_user: PopulatedUser | null;
}

export interface PopulatedStoryCampaignEnrollment extends CampaignEnrollment {
    ongoing: boolean;
    end_date: Date;
    subject: CampaignEnrollmentProfile;
}

export interface PopulatedCampaignRequest extends CampaignRequest {
    subjectKind: CampaignEnrollment['subjectKind'];
    subjectId: CampaignEnrollment['subjectId'];
}

export interface PopulatedCompany extends SupplementedCompany {
    logo_photo: Photo | null;
}

export interface UserCompany extends PopulatedCompany {
    role: IUserRole;
    account_role: boolean;
    reviewly: boolean;
    ld_company_user: {
        data: LDContext;
        hash: string;
    };
}

//  Person
export interface SupplementedPerson extends Person {
    name: string;
    initials: string;
    friendly_phone: string | null;
}

export interface PopulatedPerson extends SupplementedPerson {
    profile_photo: Photo | null;
}

export interface PopulatedPersonForPeople extends PopulatedPerson {
    campaignEnrollments: Array<CampaignEnrollment>;
    latest_review: Review | null;
}

//  ResellerSettings
export interface PopulatedResellerSettings extends ResellerSettings {
    white_label_settings: PopulatedResellerWhiteLabelSettings;
}

export interface PopulatedResellerWhiteLabelSettingsAdditions {
    android_icon?: Photo | null;
    app_icon?: Photo | null;
    ios_icon?: Photo | null;
    fav_icon?: Photo | null;
    powered_by?: Photo | null;
}

interface PopulatedResellerWhiteLabelSettings
    extends ResellerWhiteLabelSettings,
        PopulatedResellerWhiteLabelSettingsAdditions {}

//  Review
export interface SupplementedReview extends Review {
    author: SupplementedPersonChannel;
}

export interface PopulatedReview extends Review {
    person: SupplementedPerson;
}

export interface PopulatedStoryReview extends PopulatedReview {
    potentialMatches: Array<PopulatedMatch>;
}

//  Share
export interface PopulatedShare extends Share {
    user: User;
}

//  Story
export interface PopulatedStory extends Story {
    campaignEnrollments: Array<PopulatedStoryCampaignEnrollment>;
    people: Array<Person>;
    photos: Array<Photo>;
    reviews: Array<PopulatedStoryReview>;
    shares: Array<PopulatedShare>;
    user: User | null;
}

export interface SupplementedStory extends PopulatedStory {
    share_url: string;
}

//  User
export interface PopulatedTeamUser extends User {
    accountUser: boolean;
    role: IUserRole;
}

export interface SupplementedUser extends User {
    name: string;
    initials: string;
    friendly_phone: string | null;
}

export interface PopulatedUser extends SupplementedUser {
    profile_photo: Photo | null;
}

export interface PopulatedUserWithCompanies extends PopulatedUser {
    intercom_user_id_hash: string;
    intercom_user_id: string;
    intercom_user_email: string;
    intercom_user_name: string;
    Companies: Array<UserCompany>;
}

export interface PopulatedJob extends Job {
    people: Array<Person>;
}

/**
 * Common subtypes
 */
export interface SupplementedPersonChannel extends IPersonChannel {
    name: string;
    username: string;
    initials: string;
    friendly_phone: string | null;
}

//  WebsiteActivity
export interface PopulatedWebsiteActivity extends WebsiteActivity {
    call: PopulatedCall | null;
    leadForm: PopulatedLeadForm | null;
}

export interface Segment extends IEntityBase<'Segment'> {
    description: string;
    subject_kind: CampaignSubjectKind;
    rule_collection: Array<{
        equivalency: number;
        rules: Array<CampaignRule<any>>;
    }>;
}

export interface IGoogleReview {
    name: string;
    reviewer: {
        isAnonymous: boolean;
        displayName: string;
    };
    reviewReply?: {
        comment: string;
        updateTime: string;
    };
    starRating: 'STAR_RATING_UNSPECIFIED' | 'ONE' | 'TWO' | 'THREE' | 'FOUR' | 'FIVE';
    comment: string;
    createTime: string;
}
